
  // ---------------------------------------------------------------- data
  // Q1 is always asked first and decides the path. Fairway woods and hybrids are separate paths.
  var Q1 = { id:"q1", title:"What are you shopping for?", help:"Pick the one you most want to sort out first — you can always come back for the rest.", two:false, options:[
    { v:"set",     lab:"A full set",        sub:"The lot — driver through putter, ready to play" },
    { v:"driver",  lab:"A driver",          sub:"More distance and forgiveness off the tee" },
    { v:"fairway", lab:"A fairway wood",    sub:"Easier long clubs off the deck or the tee" },
    { v:"hybrid",  lab:"A hybrid / rescue", sub:"The forgiving replacement for long irons" },
    { v:"irons",   lab:"Irons",             sub:"Your scoring clubs — a single iron or a set" },
    { v:"wedges",  lab:"A wedge",           sub:"Sharper short game around the greens" },
    { v:"putter",  lab:"A putter",          sub:"Roll it truer, hole more putts" },
    { v:"notsure", lab:"Not sure — help me",sub:"We'll point you to the biggest win for your game" },
  ]};

  // ---- shared full-swing questions -----------------------------------------------------------
  var Q_GAME = { id:"q_game", title:"How's your game right now?", help:"Roughly what you'd shoot for 18 holes. Be honest — it sets how much forgiveness we build in.", two:true, options:[
    { v:"new",      lab:"Brand new to golf", sub:"Just getting into it" },
    { v:"learning", lab:"Still learning",    sub:"Usually scoring 100+" },
    { v:"getting",  lab:"Getting there",     sub:"Breaking into the 90s" },
    { v:"solid",    lab:"Pretty solid",      sub:"Shooting in the 80s" },
    { v:"low",      lab:"Low handicapper",   sub:"Regularly breaking 80" },
  ]};
  function qDist(titleLabel){ return { id:"q_dist", title:titleLabel, help:"Your best guess at a solid carry — this sets your shaft flex. 'No idea' is a fine answer.", two:true, options:[
    { v:"u200",    lab:"Under 180 m", sub:"Senior / regular flex territory" },
    { v:"200_230", lab:"180 – 210 m", sub:"Most weekend golfers live here" },
    { v:"230_260", lab:"210 – 235 m", sub:"Strong, confident swing" },
    { v:"260plus", lab:"235 m+",      sub:"You've got some speed" },
    { v:"notsure", lab:"No idea — I don't track it", sub:"We'll set it from your game" },
  ]}; }
  var Q_DIST7 = { id:"q_dist7", title:"How far do you hit your 7-iron?", help:"A solid, stock 7-iron carry — this sets your shaft flex. A rough guess is fine.", two:true, options:[
    { v:"u105",    lab:"Under 105 m", sub:"Senior / regular flex" },
    { v:"105_120", lab:"105 – 120 m", sub:"Where most golfers land" },
    { v:"120_135", lab:"120 – 135 m", sub:"Strong swing" },
    { v:"140_155", lab:"140 – 155 m", sub:"Plenty of speed" },
    { v:"160plus", lab:"160 m+",      sub:"Serious clubhead speed" },
  ]};
  var Q_MATTERS = { id:"q_matters", title:"What matters most to you?", help:"When we have to choose between two good clubs, which way should we lean?", two:true, options:[
    { v:"forgiveness", lab:"Forgiveness",    sub:"Help me on my off-centre hits" },
    { v:"distance",    lab:"More distance",  sub:"I want to hit it further" },
    { v:"feel",        lab:"Feel & control", sub:"Soft feel, shape my shots" },
    { v:"value",       lab:"Best value",     sub:"Most club for my money" },
  ]};
  var Q_MATTERS_IRONS = { id:"q_matters", title:"What matters most to you?", help:"When we choose between two good iron sets, which way should we lean?", two:true, options:[
    { v:"forgiveness", lab:"Forgiveness", sub:"Help me on my off-centre hits" },
    { v:"distance",    lab:"Distance",    sub:"Stronger lofts, more carry" },
    { v:"feel",        lab:"Shot-shaping",sub:"Workable, soft players' irons" },
    { v:"value",       lab:"Best value",  sub:"Most club for my money" },
  ]};
  var Q_MATTERS_WEDGE = { id:"q_matters", title:"What matters most to you?", help:"Which way should we lean on your wedge?", two:false, options:[
    { v:"forgiveness", lab:"Forgiveness", sub:"Wider sole, more margin for error" },
    { v:"feel",        lab:"Style",       sub:"Clean looks and premium feel" },
  ]};

  // ---- loft (fairway / hybrid) ---------------------------------------------------------------
  var Q_LOFT_FAIRWAY = { id:"q_loft", title:"What loft are you after?", help:"Higher loft launches easier and flies a touch shorter. Not sure? Pick the gap you most need to fill.", two:true, options:[
    { v:"f3", lab:"13.5° – 16°", sub:"3-wood · longest, tee or deck", lo:13.5, hi:16 },
    { v:"f4", lab:"16.5° – 18°", sub:"4-wood · a touch easier", lo:16.5, hi:18 },
    { v:"f5", lab:"18.5° – 20°", sub:"5-wood · the versatile favourite", lo:18.5, hi:20 },
    { v:"f7", lab:"21° – 22°",   sub:"7-wood · high, soft landing", lo:21, hi:22 },
  ]};
  var Q_LOFT_HYBRID = { id:"q_loft", title:"What loft are you after?", help:"Match the long iron you want to replace — higher number means more loft and more forgiveness.", two:true, options:[
    { v:"h2", lab:"16° – 18°", sub:"2-hybrid · replaces a 2/3 iron", lo:16, hi:18 },
    { v:"h3", lab:"19° – 20°", sub:"3-hybrid · the popular one", lo:19, hi:20 },
    { v:"h4", lab:"21° – 23°", sub:"4-hybrid · easy mid-long club", lo:21, hi:23 },
    { v:"h5", lab:"24° – 25°", sub:"5-hybrid · replaces a 5 iron", lo:24, hi:25 },
    { v:"h6", lab:"26° – 28°", sub:"6-hybrid · super forgiving", lo:26, hi:28 },
  ]};

  // ---- irons ---------------------------------------------------------------------------------
  var Q_IRON_COUNT = { id:"q_count", title:"How many irons do you want?", help:"A single iron to fill a gap, a standard set, or an extended set with the long irons too.", two:false, options:[
    { v:"single",   lab:"A single iron",   sub:"One iron to fill a specific gap" },
    { v:"set",      lab:"An iron set",     sub:"5-iron through PW — the usual" },
    { v:"extended", lab:"An extended set", sub:"Long irons too, e.g. 4-iron to PW" },
  ]};

  // ---- wedges --------------------------------------------------------------------------------
  var Q_WEDGE_CONF = { id:"q_conf", title:"How confident are you with your wedges?", help:"Be honest — it helps us pitch the right level of forgiveness.", two:true, options:[
    { v:"disaster", lab:"Disastrous",                sub:"Whatever's on the edge of the green" },
    { v:"streaky",  lab:"Sometimes good, often not", sub:"Hot and cold" },
    { v:"capable",  lab:"Capable, room to grow",     sub:"Mostly reliable" },
    { v:"strength", lab:"Best part of my game",      sub:"I back myself" },
  ]};
  var Q_WEDGE_DIVOT = { id:"q_divot", title:"Do you take a divot?", help:"How steeply you come into the ball — it points us to the right bounce.", two:false, options:[
    { v:"none",   lab:"No",          sub:"Sweep it · low bounce (0–6°)" },
    { v:"some",   lab:"Sometimes",   sub:"Shallow divot · mid bounce (6–10°)" },
    { v:"always", lab:"Yes, always", sub:"Steep · high bounce (10–14°)" },
  ]};
  var Q_WEDGE_GOAL = { id:"q_goal", title:"What's the goal with this wedge?", help:"What you most want it for — this sets the loft we look for.", two:true, options:[
    { v:"approach", lab:"Full approach shots",    sub:"46° – 52° · gap / pitching", lo:46, hi:52 },
    { v:"bunker",   lab:"Bunkers",                sub:"54° – 56° · sand", lo:54, hi:56 },
    { v:"flop",     lab:"The flop",               sub:"58° – 62° · high & soft", lo:58, hi:62 },
    { v:"chip",     lab:"Chipping / short shots", sub:"Around the green", lo:50, hi:58 },
    { v:"bump",     lab:"Bump & run",             sub:"37° – 46° · low runners", lo:37, hi:46 },
  ]};

  // ---- putters -------------------------------------------------------------------------------
  var Q_PUT_TYPE = { id:"q_ptype", title:"What type of putter do you prefer?", help:"Blades are compact and classic; mallets are bigger and more forgiving.", two:false, options:[
    { v:"blade",  lab:"Blade",    sub:"Compact, traditional" },
    { v:"mallet", lab:"Mallet",   sub:"Bigger, high-MOI, forgiving" },
    { v:"either", lab:"Not sure", sub:"Show me both" },
  ]};
  var Q_PUT_FEEL = { id:"q_pfeel", title:"What feel are you after?", help:"This points us to an insert (softer) or a milled face (firmer).", two:true, options:[
    { v:"soft",   lab:"Soft",    sub:"Insert face, muted feel" },
    { v:"medium", lab:"Medium",  sub:"Balanced" },
    { v:"firm",   lab:"Firm",    sub:"Milled face, clicky feedback" },
    { v:"any",    lab:"No idea", sub:"Not fussed" },
  ]};
  var Q_PUT_STROKE = { id:"q_pstroke", title:"What best describes your putting stroke?", help:"Straight strokes suit face-balanced mallets; arced strokes suit toe-hang blades.", two:true, options:[
    { v:"straight", lab:"Straight back & through", sub:"Face-balanced suits you" },
    { v:"slight",   lab:"Slight arc",              sub:"The most common" },
    { v:"strong",   lab:"Strong arc",              sub:"Toe-hang suits you" },
    { v:"unknown",  lab:"No idea what you mean",   sub:"That's fine — we'll keep it forgiving" },
  ]};
  var Q_PUT_BRAND = { id:"q_brand", title:"Any brand you're set on?", help:"We'll bump your favourite to the top — or ignore brand entirely.", two:true, options:[
    { v:"Ping",       lab:"Ping",               sub:"" },
    { v:"Callaway",   lab:"Callaway / Odyssey", sub:"" },
    { v:"TaylorMade", lab:"TaylorMade",         sub:"" },
    { v:"other",      lab:"Something else",      sub:"Surprise me" },
    { v:"any",        lab:"Don't care",         sub:"Just the best roll" },
  ]};

  // ---- budget bands (true min/max ranges; irons branch on single vs set) ---------------------
  var BUDGET_BANDS = {
    driver: [
      { v:"u200",    lab:"Under $200",  sub:"Smart value off the tee", min:0,   max:200 },
      { v:"200_400", lab:"$200 – $400", sub:"Big upgrade territory",   min:200, max:400 },
      { v:"400_650", lab:"$400 – $650", sub:"Premium, recent models",  min:400, max:650 },
      { v:"650plus", lab:"$650+",       sub:"Top-tier, near-new",      min:650, max:1e9 },
    ],
    fairway: [
      { v:"u150",    lab:"Under $150",  sub:"Smart value",            min:0,   max:150 },
      { v:"150_250", lab:"$150 – $250", sub:"The sweet spot",         min:150, max:250 },
      { v:"250_350", lab:"$250 – $350", sub:"Premium, recent models", min:250, max:350 },
      { v:"350plus", lab:"$350+",       sub:"Top-tier, near-new",     min:350, max:1e9 },
    ],
    irons_set: [
      { v:"u500",     lab:"Under $500",    sub:"Smart entry-level set", min:0,    max:500 },
      { v:"500_799",  lab:"$500 – $799",   sub:"The big-upgrade zone",  min:500,  max:799 },
      { v:"800_1099", lab:"$800 – $1,099", sub:"Premium, recent sets",  min:800,  max:1099 },
      { v:"1100plus", lab:"$1,100+",       sub:"Top-tier, near-new",    min:1100, max:1e9 },
    ],
    irons_single: [
      { v:"u129",    lab:"Under $129",  sub:"Smart value",   min:0,   max:129 },
      { v:"130_169", lab:"$130 – $169", sub:"Recent models", min:120, max:169 },
      { v:"170plus", lab:"$170+",       sub:"Premium",       min:170, max:1e9 },
    ],
    wedges: [
      { v:"u120",    lab:"Below $120",  sub:"Smart value",   min:0,   max:120 },
      { v:"130_169", lab:"$130 – $169", sub:"Recent models", min:120, max:169 },
      { v:"170plus", lab:"$170+",       sub:"Premium spin",  min:170, max:1e9 },
    ],
    putter: [
      { v:"u150",    lab:"Under $150",  sub:"Smart value",            min:0,   max:150 },
      { v:"150_249", lab:"$150 – $249", sub:"The sweet spot",         min:150, max:249 },
      { v:"250_349", lab:"$250 – $349", sub:"Premium, recent models", min:250, max:349 },
      { v:"350plus", lab:"$350+",       sub:"Top-tier, near-new",     min:350, max:1e9 },
    ],
    set: [
      { v:"u300",     lab:"Under $300",    sub:"Smart entry-level gear", min:0,    max:300 },
      { v:"300_600",  lab:"$300 – $600",   sub:"Sweet spot for upgrade", min:300,  max:600 },
      { v:"600_1000", lab:"$600 – $1,000", sub:"Premium, recent models", min:600,  max:1000 },
      { v:"1000plus", lab:"$1,000+",       sub:"Top-tier, near-new",     min:1000, max:1e9 },
    ],
  };
  function budgetBands(rawCat, st){
    var c = rawCat === "notsure" ? "set" : rawCat;
    if (c === "irons") return (st.answers.q_count === "single") ? BUDGET_BANDS.irons_single : BUDGET_BANDS.irons_set;
    if (c === "hybrid") return BUDGET_BANDS.fairway;
    return BUDGET_BANDS[c] || BUDGET_BANDS.set;
  }
  var Q_BUDGET = { id:"q_budget", title:"What's your budget?", help:"Whatever you're comfortable investing. We'll only show clubs you can actually buy today.", two:true,
    optionsFor:function(st){ return budgetBands(st.answers.q1, st); } };

  // ---- per-category flows (Q1 is prepended automatically). Ranking hierarchy, in order:
  // 1) dexterity/gender  2) club type  3) price  4) club-specific (loft/flex/iron count/putter)  5) what matters most
  function categoryFlow(cat){
    switch(cat){
      case "driver":  return [Q_GAME, qDist("How far do you hit it?"), Q_MATTERS, Q_BUDGET];
      case "fairway": return [Q_GAME, qDist("How far do you hit your <u>driver</u>?"), Q_LOFT_FAIRWAY, Q_MATTERS, Q_BUDGET];
      case "hybrid":  return [Q_GAME, qDist("How far do you hit your <u>driver</u>?"), Q_LOFT_HYBRID, Q_MATTERS, Q_BUDGET];
      case "irons":   return [Q_GAME, Q_IRON_COUNT, Q_DIST7, Q_MATTERS_IRONS, Q_BUDGET];
      case "wedges":  return [Q_WEDGE_CONF, Q_WEDGE_DIVOT, Q_WEDGE_GOAL, Q_MATTERS_WEDGE, Q_BUDGET];
      case "putter":  return [Q_PUT_TYPE, Q_PUT_FEEL, Q_PUT_STROKE, Q_PUT_BRAND, Q_BUDGET];
      default:        return [Q_GAME, qDist("How far do you hit your <u>driver</u>?"), Q_MATTERS, Q_BUDGET]; // set / notsure
    }
  }
  function loftQFor(cat){ return cat === "hybrid" ? Q_LOFT_HYBRID : Q_LOFT_FAIRWAY; }
  function optById(q, v){ var o = (q.options||[]).filter(function(x){ return x.v === v; }); return o[0] || null; }

  // LIVE SNAPSHOT — real in-stock clubs pulled from recreationstation.co.nz, refreshed 2 Jun 2026
  // against the connected store (product_type + available inventory). In production this array is
  // replaced by a live Storefront API query; the shape is identical.
  var IMG = "https://cdn.shopify.com/s/files/1/0726/8833/6930/files/";
  var PROD = "https://recreationstation.co.nz/products/";